import { render, staticRenderFns } from "./SalesOpenQuotationNumberDisplayer.vue?vue&type=template&id=6d31a3f5"
import script from "./SalesOpenQuotationNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./SalesOpenQuotationNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports